// Called by : src/App.vue (modal-sign)

<template>
  <base-modal ref="base-modal" pageId="pge_sign" pageClass="infos" modalClass="modal-lg" modalDataBack="true" modalDataKey="true">

    {{ forceUpdate }}
    <!-- {{ signature }} -->

      <template #header>
        <h4 class="modal-title" id="pge_sign_title">{{ $t('infos.signTitle') }}</h4>
        <button v-if="user.signOk" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>

      // infos.signCanvas ; infos.signImage ; infos.signChange ; 
      <template #body>
        <div id="row_sign_canvas" class="row" :class="cssCanvas">
          <div class="col-md-12 text-center">
            <p>{{ $t('infos.signCanvas') }}</p>
            <canvas id="sig-canvas" class="img-fluid" ref="rCanv" :width="nCanvasWidth" :height="nCanvasHeight">
              Get a better browser, bro. 
              <!-- 
                width="500" height="400" 
                isCanvasEmpty(this) 
                @click="alert(this.toString())"
              -->
            </canvas>
          </div>
        </div>
        <div id="row_sign_image" class="row" :class="cssImage">
          <div class="col-md-12 text-center">
            <p>{{ invite }}</p>
            <img :src="signature" id="sig-image" class="img-fluid" alt="Signature" :width="nCanvasWidth" :height="nCanvasHeight"/>
            <!-- width="500" height="400" -->
          </div>
        </div>
        <div id="row_sign_datas" class="row d-none">
          <div class="col-md-12">
            <textarea v-model="signature" ref="rSign" name="sig-dataUrl" id="sig-dataUrl" class="form-control" rows="10" cols="" placeholder=""></textarea>
          </div>
        </div>

        <br/> 
        
        <div class="row" :class="cssChange">
          <div class="col-md-12 text-center">
            <button class="btn btn-success text-uppercase px-4 py-2" id="sig-changeBtn">
              <span class="oi oi-reload mr-2"></span>
              {{ $t('modals.signChange') }}
            </button>
            <button id="sign_set_change" class="d-none" @click="change"></button>
          </div>
        </div>
        <div class="row" :class="cssCanvas">
          <div class="col-md-12 text-center">
            <button class="btn btn-secondary text-uppercase px-4 py-2 d-none" id="sig-clearBtn">
              <span class="oi oi-circle-x mr-2"></span>
              {{ $t('modals.signErase') }}
            </button>
            <button class="btn btn-primary text-uppercase px-4 py-2" id="sig-submitBtn" disabled="1">
              <span class="oi oi-check mr-2"></span>
              {{ $t('modals.signValid') }}
            </button>
            <button id="sign_get_data" class="d-none" @click="getData"></button>
          </div>
        </div>
        <!-- :disabled="getSubmintBtnDisabled() || 1" -->
      </template>

      <template #footer>
        <div v-if="user.signOk" class="w-100">
          <button type="submit" class="btn btn-secondary btn-lg bnt-block w-100" data-dismiss="modal">
            <span class="oi oi-x mr-2"></span>
            {{ $t('modals.close') }}
          </button>
        </div>
        <div v-else class="w-100">
          <div class="btn-group bnt-block w-100">
              <button class="btn btn-secondary btn-lg" data-dismiss="modal" @click="refuse">
                <span class="oi oi-ban mr-2"></span>
                {{ $t('modals.cancel') }}
              </button>
              <button class="btn btn-primary btn-lg" data-dismiss="modal" @click="accept" :disabled="getSaveBtnDisabled()">
                <span class="oi oi-check mr-2"></span>
                {{ $t('modals.save') }}
              </button>
          </div>
        </div>
      </template>

      {{ forceRefresh }}

  </base-modal>
</template>

<script>
import { constants } from '@/constants'
import BaseModal from '@/components/BaseModal'

export default {
  components: {
    BaseModal,
  },
  data() {
    return {
      init: true,
      signature: '',
      signOk: false,
      isChange: false,
      cssChange: '',
      cssImage: '',
      cssCanvas: '',
      invite: '',
      nCanvasWidth: 500,
      nCanvasHeight: 320,
      oCanvas: '',
      isCanvas: true,
    }
  },
  methods: {
    setCanvas(obj) {
      this.oCanvas = obj;
    },
    getSaveBtnDisabled() {
      return Boolean(!this.signature);
    },
    getSubmintBtnDisabled() {
      return this.isCanvas;
    },
    getData() {
      this.signature = f_getSignDataUrl_s();
    },
    accept() {
      this.model.setUserSignature(this.user, this.signature);
      this.user.signOk = Boolean(1);
      this.user.signB64 = this.signature;
      f_eraseSignDataUrl_v();
      $('#pge_sign').modal('hide');
    },
    change() {
      // this.model.setUserSignature(this.user, '');
      this.user.signOk = Boolean(0);
      this.user.signB64 = '';
      this.signature = '';
    },
    refuse() {
      this.user.signOk = Boolean(0);
      // this.user.signB64 = '';
    },
    isCanvasEmpty(canv) {
      // var canv = document.getElementById('sig-canvas');
      var sctx = canv.getContext('2d');
      var pxl = new Uint32Array(sctx.getImageData(0, 0, canv.width, canv.height).data.buffer);
      var oky = !Boolean(pxl.some(color => color !== 0));
      this.isCanvas = oky;
    },
    signInit() {
      var sSign = this.user.signB64;
      var sB64 = 'data:image/png;base64,';
      var sTst = 'ata:image/png;base64';
      var bB64 = Boolean(sSign && !sSign.includes(sTst));
      
      this.signature = (bB64) ? sB64 + sSign : sSign;
      this.signOk = this.user.signOk;
      this.isChange = this.params.isSignChange;
      this.cssChange = (this.signOk && this.isChange) ? '' : 'd-none';
      this.cssImage = (this.signOk) ? '' : 'd-none';
      this.cssCanvas = (!this.signOk) ? '' : 'd-none';

      // this.invite = (this.signOk && this.isChange) ? this.$t('infos.signChange') : this.$t('infos.signImage');

      if (this.signOk && this.isChange) {
        this.invite = this.$t('infos.signChange');
      } else if (this.signOk && !this.isChange) {
        this.invite = ' ';
      } else {
        this.invite = this.$t('infos.signImage');
      }
      
      f_setSignCanvasSize_v();
      var aCanvasSize = f_getSignCanvasSize_a();
      console.log('modal.canvas.size', aCanvasSize.join('-'));
      this.nCanvasWidth = aCanvasSize[0];
      this.nCanvasHeight = aCanvasSize[1];
      // this.oCanvas = document.getElementById('sig-canvas');
      // this.oCanvas = this.$refs["rCanv"];
      // console.log('oCanvas', this.oCanvas);
    },
    /*
    SignOk = 0 ; isChange = 0-1
      canvas = 1
      image = 0
      validate = 1 ; cancel = 0-1
      change = 0

    SignOk = 1 ; isChange = 0
      canvas = 0
      image = 1
      validate = 0 ; cancel = 0
      change = 0

    SignOk = 1 ; isChange = 1
      canvas = 0
      image = 1
      validate = 0 ; cancel = 0
      change = 1
    */
  },
  mounted: function() {
    // console.log('mounted:function');
    this.signInit(); 
  },
  computed: {
    forceUpdate() {
      // console.log('computed:forceUpdate');
      // this.signInit();
      return '';
    },
    forceRefresh() {
      // console.log('computed:forceRefresh');
      this.signInit();
      return '';
    },
    constants() {
      return constants
    },
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$store.state.user
    },
    params() {
      return this.$store.state.params
    },  
  },
}
</script>

<style scoped>
.row, .col-md-12, #sig-canvas, #sig-image {
  margin: 0;
  padding: 0;
  box-sizing: content-box !important;
}
#sig-canvas {
  border: 2px solid #9cf;
  border-radius: 1rem;
  margin-bottom: -6px;
  cursor: url(/src/assets/cursor.svg), pointer; 
}
#sig-canvas:hover {
  border-color: #69c;
}
#sig-image {
  border: 2px solid #ccc;
  border-radius: 1rem;
}
#sig-image:hover {
  border-color: #999;
}

/*
  width: 500px;
  height: 400px;
*/
</style>



// WEBPACK FOOTER //
// src/components/misc/ModalSign.vue